import React, { useCallback, useRef, useState } from "react";
import { useAudit } from "../../contexts/auditSessionContext";
import { fetchFastApi } from "../../utils/fastApi";
import { Button } from "@fluentui/react-components";

export const UploadFilesToSession: React.FC = () => {
  const { auditSession, setAuditSession } = useAudit();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [isUploading, setIsUploading] = useState(false);

  const uploadDocumentsToAuditSession = useCallback(
    async (documents: File[]) => {
      if (!auditSession?.id) {
        console.error("Audit session not found");
        return;
      }
      try {
        setIsUploading(true);
        const formData = new FormData();
        documents.forEach((file) => {
          formData.append("files", file);
        });

        formData.append("should_match_documents", "false");

        await fetchFastApi({
          method: "POST",
          path: `/matching/match-session/${auditSession?.id}/upload-documents`,
          body: formData,
        });
        setAuditSession((prev) => {
          console.log("prev", prev);
          if (!prev) return prev;
          return {
            ...prev,
            documentsState: "processing",
          };
        });
        setIsUploading(false);
        return;
      } catch (error) {
        console.error("Error uploading documents:", error);
        setIsUploading(false);
        throw error;
      }
    },
    [auditSession, setAuditSession]
  );

  const handleFileChange = useCallback(
    async (event: React.ChangeEvent<HTMLInputElement>) => {
      const files = event.target.files;
      if (files && files.length > 0) {
        await uploadDocumentsToAuditSession(Array.from(files));
      }
    },
    [uploadDocumentsToAuditSession]
  );

  return (
    <div>
      <input type="file" ref={fileInputRef} onChange={handleFileChange} multiple style={{ display: "none" }} />
      <Button appearance="primary" onClick={() => fileInputRef.current?.click()} disabled={isUploading}>
        {isUploading ? "Uploading..." : "Upload Files"}
      </Button>
    </div>
  );
};
